module.exports = __webpack_public_path__ + "img/background-light.5970eee7.svg";